import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-navigation-buttons',
  imports: [
    CommonModule,
    MatButton,
    TranslateModule
  ],
  templateUrl: './navigation-buttons.component.html',
  styleUrl: './navigation-buttons.component.scss'
})
export class NavigationButtonsComponent {
  @Input() index: number;
  @Input() length: number;
  @Output() previous: EventEmitter<void> = new EventEmitter();
  @Output() next: EventEmitter<void> = new EventEmitter();

  constructor() {}

  onPrevious() {
    this.previous.emit();
  }

  onNext() {
    this.next.emit();
  }
}
